import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl sm:rounded-2xl p-4 sm:p-6 border-2 border-purple-100" }
const _hoisted_2 = {
  key: 0,
  class: "text-center py-8 sm:py-12 bg-white/60 rounded-xl border-2 border-dashed border-purple-200"
}
const _hoisted_3 = { class: "space-y-3" }
const _hoisted_4 = { class: "flex justify-between items-start mb-3" }
const _hoisted_5 = { class: "text-xs sm:text-sm font-semibold text-purple-600" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3" }
const _hoisted_8 = ["value", "onInput"]
const _hoisted_9 = ["value", "onInput"]

import { ref, watch, computed } from "vue";

interface Especificacion {
  nombreEspTecnicas: string;
  detallesEspTecncias: string;
}

interface Props {
  especificaciones: Especificacion[];
}

interface Emits {
  (e: "update:especificaciones", value: Especificacion[]): void;
  (e: "agregar"): void;
  (e: "eliminar", index: number): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EspecificacionesTecnicas',
  props: {
    especificaciones: {}
  },
  emits: ["update:especificaciones", "agregar", "eliminar"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const especificacionesLocal = computed({
  get: () => props.especificaciones,
  set: (val) => emit("update:especificaciones", val),
});

const agregarEspecificacion = () => {
  emit("agregar");
};

const eliminarEspecificacion = (index: number) => {
  emit("eliminar", index);
};

const actualizarEspecificacion = (index: number, field: keyof Especificacion, value: string) => {
  const nuevasEspecificaciones = [...props.especificaciones];
  nuevasEspecificaciones[index][field] = value;
  emit("update:especificaciones", nuevasEspecificaciones);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "flex items-center justify-between mb-4 sm:mb-6" }, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"flex items-center gap-2 sm:gap-3\"><div class=\"bg-purple-600 p-2 sm:p-2.5 rounded-lg\"><svg class=\"w-5 h-5 sm:w-6 sm:h-6 text-white\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z\"></path><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15 12a3 3 0 11-6 0 3 3 0 016 0z\"></path></svg></div><h3 class=\"text-lg sm:text-xl font-bold text-slate-800\">Especificaciones Técnicas</h3></div>", 1)),
      _createElementVNode("button", {
        onClick: agregarEspecificacion,
        class: "px-3 sm:px-4 py-1.5 sm:py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors flex items-center gap-1.5 sm:gap-2 text-xs sm:text-sm"
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("svg", {
          class: "w-4 h-4 sm:w-5 sm:h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })
        ], -1),
        _createElementVNode("span", { class: "hidden sm:inline" }, "Agregar", -1),
        _createElementVNode("span", { class: "sm:hidden" }, "+", -1)
      ]))])
    ]),
    (__props.especificaciones.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            class: "w-12 h-12 sm:w-16 sm:h-16 mx-auto text-purple-300 mb-3",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            })
          ], -1),
          _createElementVNode("p", { class: "text-slate-600 text-sm sm:text-base" }, "No hay especificaciones técnicas", -1),
          _createElementVNode("p", { class: "text-slate-500 text-xs sm:text-sm mt-1" }, "Haz clic en \"Agregar\" para comenzar", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.especificaciones, (esp, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "bg-white/80 p-3 sm:p-4 rounded-lg sm:rounded-xl border-2 border-purple-100"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, "Especificación #" + _toDisplayString(index + 1), 1),
            _createElementVNode("button", {
              onClick: ($event: any) => (eliminarEspecificacion(index)),
              class: "text-red-600 hover:bg-red-50 rounded-lg p-1 sm:p-1.5 transition-colors"
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("svg", {
                class: "w-4 h-4 sm:w-5 sm:h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                })
              ], -1)
            ]))], 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("input", {
              value: esp.nombreEspTecnicas,
              onInput: ($event: any) => (actualizarEspecificacion(index, 'nombreEspTecnicas', ($event.target as HTMLInputElement).value)),
              class: "w-full px-3 sm:px-4 py-2 text-sm sm:text-base border-2 rounded-lg focus:border-purple-500 focus:outline-none",
              placeholder: "Nombre (ej: Peso)"
            }, null, 40, _hoisted_8),
            _createElementVNode("input", {
              value: esp.detallesEspTecncias,
              onInput: ($event: any) => (actualizarEspecificacion(index, 'detallesEspTecncias', ($event.target as HTMLInputElement).value)),
              class: "w-full px-3 sm:px-4 py-2 text-sm sm:text-base border-2 rounded-lg focus:border-purple-500 focus:outline-none",
              placeholder: "Detalle (ej: 2.5 kg)"
            }, null, 40, _hoisted_9)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})